import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LanguageLoader } from '../../../assets/languages/index.js';
import Addresses from "../../../components/features/Addresses.jsx";
import api from "../../../services/axios.js";
import { config } from "../../../services/config.js";
import { Toastify } from '../../../components/utils/index.js';
import { CheckNationalCode } from '../../../components/utils/validation.js';

const CreateAccounts = () => {
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [firstName, SetFirstName] = useState('');
	const [lastname, SetLastName] = useState('');
	const [fatherName, SetFatherName] = useState('');
	const [nationalCode, SetNationalCode] = useState('');
	const [phone, SetPhone] = useState('');
	const [phoneId, SetPhoneId] = useState('');
	const [addresses, SetAddress] = useState([]);
	const [accountId, SetAccountId] = useState('');
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const id = searchParams.get("id");
	const BackTo = searchParams.get("BackTo");

	useEffect(() => {
		if (id) {
			FetchAccountById(id);
			return;
		}
		const phoneParam = searchParams.get('phone');
		if (phoneParam) {
			SetPhone(phoneParam);
		}
	}, [searchParams]);

	const getPrimaryPhone = (item) => {
		if (Array.isArray(item?.phone_number) && item.phone_number.length > 0) {
			return String(item.phone_number[0] || '').replace(/\D/g, '');
		}
		if (item?.phone_number) {
			return String(item.phone_number).replace(/\D/g, '');
		}
		if (Array.isArray(item?.numbers) && item.numbers.length > 0) {
			const primary = item.numbers.find((number) => number.primary_number == 1 || number.primary == 1) || item.numbers[0];
			return String(primary?.number || '').replace(/\D/g, '');
		}
		return '';
	};

	const FetchAccountById = async (recordId) => {
		try {
			const APIResponse = await api.post(
				config.api + '?method=FetchAccountById',
				JSON.stringify({ id: recordId })
			);
			const item = APIResponse?.data || APIResponse?.[0] || APIResponse;
			if (!item?.id) {
				Toastify("خطا در دریافت اطلاعات");
				return;
			}
			SetAccountId(item.id);
			SetFirstName(item.first_name || '');
			SetLastName(item.last_name || '');
			SetFatherName(item.father_name || '');
			SetNationalCode(item.national_number || '');
			SetAddress(Array.isArray(item.addresses) ? item.addresses : []);
			const primaryPhone = getPrimaryPhone(item);
			SetPhone(primaryPhone);
			if (Array.isArray(item.numbers) && item.numbers.length > 0) {
				const primary = item.numbers.find((number) => number.primary_number == 1 || number.primary == 1) || item.numbers[0];
				SetPhoneId(primary?.id || '');
			}
		} catch (error) {
			Toastify("خطا در دریافت اطلاعات");
		}
	};

	const DoSave = async () => {
		if (!firstName || !lastname) {
			Toastify('نام و نام خانوادگی الزامی است');
			return;
		}
		if (!fatherName || !fatherName.trim()) {
			Toastify('نام پدر الزامی است');
			return;
		}
		if (!phone) {
			Toastify('شماره همراه الزامی است');
			return;
		}
		if (!nationalCode) {
			Toastify('کدملی الزامی است');
			return;
		}
		if (!CheckNationalCode(nationalCode, 'Individual')) {
			Toastify('لطفا کد ملی صحیح وارد کنید');
			return;
		}
		if (!addresses || addresses.length === 0) {
			Toastify('آدرس الزامی است');
			return;
		}
		const data = {
			id: accountId || id || undefined,
			first_name: firstName,
			last_name: lastname,
			father_name: fatherName.trim(),
			national_number: nationalCode,
			addresses: addresses,
			phone: phone,
			phone_id: phoneId,
			numbers: [{
				id: phoneId || '',
				number: phone,
				type: 'Mobile',
				primary: '1',
				sms: '1',
				phoneCode: '+98',
				phoneFlag: 'IR',
			}],
		};
		const method = 'CreateAccount';
		const APIResponse = await api.post(
			config.api + '?method=' + method,
			JSON.stringify(data)
		);
		if (!(APIResponse && (APIResponse.result == true || APIResponse.id))) {
			Toastify('خطا در ذخیره مشتری');
			return;
		}
		if (BackTo === 'CreateRetail_Orders') {
			const params = new URLSearchParams();
			const primaryPhone = String(phone).replace(/\D/g, '');
			if (primaryPhone) {
				params.set('phone', primaryPhone);
			}
			const qs = params.toString();
			navigate(`/dynamic/CreateRetail_Orders${qs ? `?${qs}` : ''}`);
			return;
		}
		navigate(`/detail/Accounts/${APIResponse.id}`);
	};

	return <>
		<div className='title flex justify-between w-full'>
			<h6>{id ? 'ویرایش مشتری' : 'ایجاد مشتری'}</h6>
			<div className="flex">
				<button onClick={DoSave} type="button" className="btn btn-primary">
					{language.SAVE}
				</button>
			</div>
		</div>
		<div className="flex flex-wrap">
			<div className="Field_Container">
				<div className="flex">
					<label>نام <span className="text-danger">*</span></label>
				</div>
				<input
					type="text"
					className="form-control"
					value={firstName}
					onChange={(e) => {
						const value = e.target.value;
						if (/^[a-zA-Zآ-ی\s]*$/.test(value)) {
							SetFirstName(value);
						}
					}}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>نام خانوادگی <span className="text-danger">*</span></label>
				</div>
				<input
					type="text"
					className="form-control"
					value={lastname}
					onChange={(e) => {
						const value = e.target.value;
						if (/^[a-zA-Zآ-ی\s]*$/.test(value)) {
							SetLastName(value);
						}
					}}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>نام پدر <span className="text-danger">*</span></label>
				</div>
				<input
					type="text"
					className="form-control"
					value={fatherName}
					onChange={(e) => {
						const value = e.target.value;
						if (/^[a-zA-Zآ-ی\s]*$/.test(value)) {
							SetFatherName(value);
						}
					}}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>شماره همراه <span className="text-danger">*</span></label>
				</div>
				<input
					type="text"
					className="form-control"
					value={phone}
					onChange={(e) => {
						const value = e.target.value;
						if (/^\d{0,11}$/.test(value)) {
							SetPhone(value);
						}
					}}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>کدملی <span className="text-danger">*</span></label>
				</div>
				<input
					type="text"
					className="form-control"
					maxLength="10"
					value={nationalCode}
					onChange={(e) => {
						const value = e.target.value;
						if (/^\d{0,10}$/.test(value)) {
							SetNationalCode(value);
							if (value.length === 10 && !CheckNationalCode(value, 'Individual')) {
								Toastify("لطفا کد ملی صحیح وارد کنید");
							}
						}
					}}
				/>
			</div>
			<div className="Field_Container">
				<div className="flex">
					<label>آدرس <span className="text-danger">*</span></label>
				</div>
				<Addresses
					onChange={(value) => SetAddress(value)}
					defaultValue={addresses}
				></Addresses>
			</div>
		</div>
	</>
}

export default CreateAccounts;
